import { Stack, CircularProgress } from "@mui/material";

import useFetch from "../../../hooks/useFetch";
import { urlCertification } from "../../../helpers";
import { CertificationScreen } from "../CertificationScreen";

export const FetchCertificationScreen = () => {
    const { data, loading } = useFetch(urlCertification, 'GET');

    if (loading) {
        return (
            <Stack width='100%' alignItems='center' justifyContent='center' mt='2rem'>
                <CircularProgress />
            </Stack>
        );
    }

    return <CertificationScreen dataClient={data} />;
}